module.exports = __webpack_public_path__ + "static/media/26.227327a5.mp3";